module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section05_04_american-village-d7ed0bc5faaf391d17029faf775c57f3.jpg";